import useTranslation from 'next-translate/useTranslation';
import { MouseEventHandler } from 'react';

import { Translate } from '@core/constant';
import { EButtonVariant, ERouting } from '@core/type';

import { LinkTranslatedStyledAsButton } from '../link-translated';
import { ButtonCustomProps } from './interface-button';

export const ButtonOpenAccount = ({
  onClick,
  ...props
}: Omit<ButtonCustomProps, 'as' | 'onClick'> & {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}): JSX.Element => {
  const { t } = useTranslation(Translate.common.BUTTON);

  return (
    <LinkTranslatedStyledAsButton
      keyRoute={ERouting.SIGN_UP}
      variant={EButtonVariant.OUTLINED}
      {...props}
    >
      {t('openAccount.title')}
    </LinkTranslatedStyledAsButton>
  );
};
